import { useSearch } from "@/contexts/SearchProvider";
import { Search } from "lucide-react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

interface SearchBarV2Props {
  value: string;
  onChange: (value: string) => void;
}

export default function SearchBarV2({ value, onChange }: SearchBarV2Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const { isSearchActive, activateSearch } = useSearch();

  const handleClick = () => {
    activateSearch();
  };

  useEffect(() => {
    if (isSearchActive) {
      inputRef.current?.focus();
    }
  }, [isSearchActive]);

  return (
    <div
      className="relative flex justify-center flex-1 min-w-0 cursor-pointer"
      onClick={handleClick}
    >
      <div
        className={`flex items-center rounded-full bg-gray-100 p-2 transition-all duration-300 ease-in-out focus-within:border-4 focus-within:border-primary border border-gray-300 ${
          isSearchActive ? "w-full" : "w-full md:w-64"
        }`}
      >
        <Search className="shrink-0" />
        <input
          ref={inputRef}
          type="text"
          placeholder={t("search_in_kaman")}
          className="flex-1 min-w-0 bg-transparent px-2 focus:outline-none cursor-pointer"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
